<template>
  <div id="nsc" v-show="hasNSCs">
    <table class="table">
      <tr class="noborder-left ">
        <th class="noborder-left" rowspan="2">NSC</th>
        <th v-for="wave in kpi.SurveyWave" :key="wave.id">{{ wave.Name }}</th>
      </tr>
      <tr class="noborder-left">
        <th v-for="wave in kpi.SurveyWave" :key="wave.id">{{ wave.ResultNSC }}</th>
      </tr>
    </table>
  </div>
</template>

<script>

  export default {
    name: 'WideNscItem',
    data() {
      return {
      }
    },

    props:[
      'overallByWave',
      'hasBorder',
      'isInline',
      'isSmall',
      'kpi'
    ],

    methods: {
      hasWaves() {
        return this.kpi && this.kpi.SurveyWave && _.size(this.kpi.SurveyWave) > 0
      },
    },

    computed: {
      waveCount: function () {
        if (!this.hasWaves) return 0
        return _.size(this.kpi.SurveyWave)
      },

      hasNSCs: function () {
        if (!this.hasWaves) return false
        return !_.find(this.kpi.SurveyWave, function(o) { return !o.ResultNSC })
      }
    }
  }
</script>


<style scoped>

#nsc {
  position: relative;
  top: 3px;
  height: 33.33px;
  display: inline-block;
  max-width: 120px;
  line-height: 1.0
}

table,
th,
tr,
td {
	border: 1px solid;
  border-color: #f5f5f5;
  padding: 0px;
}

.table {
  background: transparent;
  margin:0 auto;
  height: auto;
  border-collapse: collapse;
}

td {
  font-size: 10px;
  text-align: center;
  letter-spacing: -0.05em;
  padding: 1px;
  vertical-align:middle;
}

th {
  font-size: 10px;
  letter-spacing: -0.0em;
  font-style: bold;
  vertical-align:middle;
  text-align: center;
  width: 20%;
}

tr {
  page-break-after:auto;
  page-break-inside:avoid;
  height:4.25mm;
  page-break-inside:avoid;
  vertical-align:middle;
  text-align: center;
}

</style>
